import { createI18n, type I18n } from 'vue-i18n'
import pl from '@/locales/pl'
import validationMessages from '@/locales/pl/validation.json'

export const messages = {
  pl: {
    ...pl,
    validation: {
      ...validationMessages
    }
  }
}

export const additionalOptions = {
  locale: import.meta.env.VITE_APP_I18N_LOCALE || 'pl',
  fallbackLocale: import.meta.env.VITE_APP_I18N_FALLBACK_LOCALE || 'pl',
  globalInjection: true,
  legacy: false,
  escapeParameter: true,
  warnHtmlMessage: false
}

export const i18n: I18n = createI18n({
  messages,
  ...additionalOptions
})
